import { c as _c } from "react/compiler-runtime";
import { IcoCopy16 } from '@onefootprint/icons';
import { CopyButton } from '@onefootprint/ui';
import { cx } from 'class-variance-authority';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
type DetailsLineProps = {
  lead?: string | false;
  ipAddress?: string;
  place?: string;
};

/** A row's "lead · IP · place" line. Hovering the IP slides its copy button out from behind it, pushing the place aside. */
const DetailsLine = t0 => {
  const $ = _c(8);
  const {
    lead,
    ipAddress,
    place
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "deviceInsights"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t1);
  let t2;
  if ($[1] !== ipAddress || $[2] !== t) {
    t2 = ipAddress && <span className={cx("group/ip relative transition-[padding] duration-150 ease-out motion-reduce:transition-none", "hover:pr-4.5 has-focus-visible:pr-4.5 pointer-coarse:pr-4.5", "delay-150 hover:delay-0 has-focus-visible:delay-0")}><span className={cx("pointer-events-none absolute inset-y-0 right-0 flex -translate-x-1.5 items-center opacity-0 transition-[opacity,translate] duration-200 ease-in-out motion-reduce:transition-none", "group-hover/ip:pointer-events-auto group-hover/ip:translate-none group-hover/ip:opacity-100 group-hover/ip:duration-150 group-hover/ip:ease-out", "group-has-focus-visible/ip:pointer-events-auto group-has-focus-visible/ip:translate-none group-has-focus-visible/ip:opacity-100", "pointer-coarse:pointer-events-auto pointer-coarse:translate-none pointer-coarse:opacity-100")}><CopyButton contentToCopy={ipAddress} ariaLabel={t(_temp)} tooltip={{
          position: "top"
        }} className="relative text-tertiary transition-colors after:absolute after:-inset-1.5 hover:text-primary"><IcoCopy16 className="size-3.5" /></CopyButton></span><span className="relative">{ipAddress}</span></span>;
    $[1] = ipAddress;
    $[2] = t;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const ip = t2;
  let t3;
  if ($[4] !== ip || $[5] !== lead || $[6] !== place) {
    const parts = [lead, ip, place].filter(Boolean);
    t3 = parts.map(_temp2);
    $[4] = ip;
    $[5] = lead;
    $[6] = place;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default DetailsLine;
function _temp($) {
  return $.copyIpAddress;
}
function _temp2(part, index) {
  return <Fragment key={index}>{index > 0 && " \xB7 "}{part}</Fragment>;
}